var React = require('react');

function IconEdit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34","key":0}),React.createElement("polygon",{"points":"18 2 22 6 12 16 8 16 8 12 18 2","key":1})]);
}

IconEdit.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-edit"};

module.exports = IconEdit;

IconEdit.default = IconEdit;
